module.exports = __webpack_public_path__ + "img/1.31_Russian_road_sign.580733a3.svg";